/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Project_Overview_BlurbInputs */



/**
* | output |
* | --- |
* | "Projects are isolated workspaces. Each keeps its own chats, instructions, and references, which makes them ideal for separate teams, clients, or use cases." |
*
* @param {Uno_Edu_Project_Overview_BlurbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_project_overview_blurb = /** @type {((inputs?: Uno_Edu_Project_Overview_BlurbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Project_Overview_BlurbInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekte sind isolierte Arbeitsbereiche. Jedes behält eigene Chats, Anweisungen und Referenzen, was sie ideal für verschiedene Teams, Kunden oder Anwendungsfälle macht.")
	return /** @type {LocalizedString} */ ("Projects are isolated workspaces. Each keeps its own chats, instructions, and references, which makes them ideal for separate teams, clients, or use cases.")
});